import React, { useState } from "react";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";
import { Check } from "lucide-react";
import { editRequestStatus } from "../../actions/requestKnowledge";

const STATUS_OPTIONS = [
  { value: "", label: "Choisir un statut…" },
  { value: "0", label: "À traiter — remettre dans la file" },
  { value: "2", label: "Terminée — publiée sur Skills" },
  { value: "3", label: "Annulée — non réalisable ou doublon" },
];

const KnowledgeStatus = ({ knowledge, closeModalValidation }) => {
  const [requestStatus, setRequestStatus] = useState("");
  const [saving, setSaving] = useState(false);
  const dispatch = useDispatch();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!requestStatus) return;
    setSaving(true);
    try {
      await dispatch(editRequestStatus(knowledge?.id, requestStatus));
      toast.success("Statut mis à jour");
      // La modale n'existe que dans certains contextes : appel optionnel.
      closeModalValidation?.();
    } catch (error) {
      toast.error("La mise à jour a échoué, réessayez.");
    } finally {
      setSaving(false);
    }
  };

  return (
    <form className="req-status-form" onSubmit={handleSubmit}>
      <p className="req-status-hint">
        Sélectionnez le nouveau statut de la demande pour la traiter.
      </p>
      <div className="req-status-controls">
        <select
          className="req-status-select"
          value={requestStatus}
          onChange={(e) => setRequestStatus(e.target.value)}
        >
          {STATUS_OPTIONS.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
        <button
          type="submit"
          className="ds-btn ds-btn--primary"
          disabled={!requestStatus || saving}
        >
          <Check size={15} />
          {saving ? "Enregistrement…" : "Valider"}
        </button>
      </div>
    </form>
  );
};

export default KnowledgeStatus;
